import React from 'react';
import { motion } from 'framer-motion';
import { ShirtIcon, SmartphoneIcon, LinkIcon } from 'lucide-react';
const steps = [{
  number: '01',
  icon: ShirtIcon,
  title: 'Wear It',
  description: 'Put on your Qtap Smart T-Shirt. Premium sportswear that looks and feels incredible.'
}, {
  number: '02',
  icon: SmartphoneIcon,
  title: 'Tap It',
  description: 'Hold any NFC-enabled phone near the chip on your sleeve or chest.'
}, {
  number: '03',
  icon: LinkIcon,
  title: 'Connect',
  description: 'Instantly share your profile, social links, stats, or exclusive content. No app needed.'
}];
export function HowItWorksSection() {
  return <section id="how-it-works" className="pt-4 pb-0 md:py-20 bg-brand-dark relative" data-id="element-281">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-282">
        <div className="text-center max-w-3xl mx-auto mb-4 md:mb-16" data-id="element-283">
          <span className="text-brand-cyan font-bold tracking-widest uppercase text-xs md:text-sm mb-3 block" data-id="element-284">
            How It Works
          </span>
          <h2 className="text-2xl md:text-5xl font-heading font-bold" data-id="element-285">
            3 Easy Steps to <span className="text-gradient" data-id="element-286">Get Started</span>
          </h2>
        </div>

        <div className="relative" data-id="element-287">
          {/* Connecting Line (Desktop only) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-brand-cyan/30 to-transparent -translate-y-1/2 z-0" data-id="element-288"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-8 relative z-10" data-id="element-289">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="glass-card p-5 md:p-10 text-center relative group hover:-translate-y-2 transition-transform duration-300" data-id="element-290">
                <div className="absolute -top-4 md:-top-6 left-1/2 -translate-x-1/2 text-4xl md:text-6xl font-heading font-black text-white/5 group-hover:text-brand-cyan/10 transition-colors" data-id="element-291">
                  {step.number}
                </div>

                <div className="w-14 h-14 md:w-20 md:h-20 mx-auto bg-brand-darkest rounded-full border border-white/10 flex items-center justify-center mb-4 md:mb-6 shadow-[0_0_30px_rgba(0,212,255,0.1)] group-hover:shadow-[0_0_30px_rgba(0,212,255,0.3)] transition-shadow" data-id="element-292">
                  <step.icon className="w-7 h-7 md:w-10 md:h-10 text-brand-cyan" data-id="element-293" />
                </div>

                <h3 className="text-lg md:text-2xl font-bold mb-2 md:mb-4" data-id="element-294">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-xs md:text-base leading-relaxed" data-id="element-295">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}